<span
  class="cancel-shift-display"
  [class.shift-cancel-warning]="isAboveThreshold">
  {{ showDefaultDisplay ? shiftCancelPercentDefaultDisplay : (shiftCancelPercent | percent) }}
</span>
